<template>
  <div class="fal">
    <div v-for="(a, i) in attachments" :key="a.fileName + '-' + i" class="fal-item">
      <img
        v-if="a.fileType === 'image'"
        :src="a.url"
        class="fal-img"
        :alt="a.fileName"
        @click="open(a, i)"
      />
      <video
        v-else-if="a.fileType === 'video'"
        :src="a.url"
        class="fal-video"
        preload="metadata"
        controls
      />
      <audio
        v-else-if="a.fileType === 'audio'"
        :src="a.url"
        class="fal-audio"
        controls
      />
      <div v-else class="fal-file" role="button" tabindex="0" @click="open(a, i)" @keydown.enter="open(a, i)" @keydown.space.prevent="open(a, i)">
        <f7-icon :f7="fileIcon(a)" :size="18" :style="{ color: fileColor(a) }" />
        <span class="fal-file-meta">
          <span class="fal-file-name">{{ a.fileName }}</span>
          <span v-if="a.size" class="fal-file-size">{{ fileSize(a.size) }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { f7 } from 'framework7-vue'

defineProps({
  attachments: { type: Array, default: () => [] },
})

function fileSize(bytes) {
  if (!bytes) return ''
  if (bytes < 1024) return `${bytes} o`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} Ko`
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`
}

function isPdf(a) {
  return (a.contentType || '').includes('pdf')
}

function fileIcon(a) {
  return isPdf(a) ? 'doc_on_doc' : 'doc_text'
}

function fileColor(a) {
  return isPdf(a) ? '#C0440A' : '#8e8e93'
}

function open(a, i) {
  if (['image', 'video', 'audio'].includes(a.fileType) || isPdf(a)) {
    const photos = attachments.map((x) => {
      if (x.fileType === 'image') return { url: x.url, caption: x.fileName }
      if (x.fileType === 'video') return { html: `<video src="${x.url}" controls style="width: 100%"></video>`, caption: x.fileName }
      if (x.fileType === 'audio') return { html: `<audio src="${x.url}" controls style="width: 100%"></audio>`, caption: x.fileName }
      if (isPdf(x)) return { html: `<iframe src="${x.url}" style="width: 100%; height: 100%; border: none"></iframe>`, caption: x.fileName }
      return { url: x.url }
    })
    f7.photoBrowser.open({ photos, initialSlide: i })
  } else {
    window.open(a.url, '_blank')
  }
}
</script>

<style scoped>
.fal {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}
.fal-item { min-width: 0; }
.fal-img {
  display: block;
  width: 96px;
  height: 96px;
  object-fit: cover;
  border-radius: 6px;
  cursor: pointer;
}
.fal-video {
  width: 180px;
  max-width: 100%;
  height: auto;
  max-height: 140px;
  border-radius: 6px;
}
.fal-audio {
  width: 180px;
  max-width: 100%;
  height: 32px;
}
.fal-file {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--f7-list-bg-color, #f5f5f5);
  border: 0.5px solid var(--f7-list-item-border-color, var(--f7-list-item-border-color, #e0e0e0));
  border-radius: 8px;
  padding: 5px 8px;
  cursor: pointer;
  max-width: 100%;
}
.fal-file-meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.fal-file-name {
  font-size: 10px;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.fal-file-size { font-size: 9px; color: var(--f7-on-surface-variant, #8e8e93); }
</style>
